<template>
  <div class="containerimg">
    <v-container fluid>
      <v-layout>
        <v-row>
          <v-col>
            <v-img src="@/assets/imgs/Asset 1@2x.png" class="logoimg"></v-img>
          </v-col>
        </v-row>
      </v-layout>
      <v-layout>
        <v-row class="mt-8">
          <v-col cols="12" lg="5" md="12" sm="12">
            <v-img
              src="@/assets/imgs/apple-iphone-1@2x.png"
              class="phoneimg"
            ></v-img>
          </v-col>
          <v-col cols="12" lg="7" md="12" sm="12">
            <v-list-item class="title">
              <v-list-item-content>
                <v-list-item-title
                  style="font-size:60px; color:#363636; font-weight:600;"
                  class="Title"
                >
                  Seed
                </v-list-item-title>
                <v-list-item-subtitle
                  class="mt-4 subtitle"
                  style="font-size:45px; color:#363636;"
                >
                  True value of company
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-row class="d-flex justify-center">
              <v-col cols="6" lg="4" md="5" sm="6">
                <a :href="IOSlink">
                  <v-img
                    src="@/assets/imgs/app store.png"
                    class="appleimg"
                    alt="IOSimg"
                  ></v-img>
                </a>
              </v-col>
              <v-col cols="6" lg="4" md="5" sm="6">
                <a :href="Googlelink">
                  <v-img
                    src="@/assets/imgs/google play.png"
                    class="googleimg"
                    alt="googlePlay"
                  ></v-img>
                </a>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    permissionDialog: false,
    permissionMessage: "",
    // breadcrumbs: [
    //   {
    //     image: "house.png"
    //   },
    //   {
    //     text: "feedbackbox"
    //   }
    // ],
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    paginationCount: [{ title: 10 }, { title: 20 }, { title: 30 }],
    items: [],
    editData: {},
    dialog: false,
    successDialog: false,
    message: "",
    search: null,
    loading: true,
    Platform: "",
    linkUri: "",
    IOSlink: "https://apps.apple.com/th/app/seedkm/id1534522681",
    Googlelink:
      "https://play.google.com/store/apps/details?id=com.fusionsol.FusionSeed"
  }),
  mounted() {
    this.Get_URL();
  },
  methods: {
    Get_URL() {
      let self = this;
      self.userAgent = navigator.userAgent || navigator.vendor;

      if (/android/i.test(self.userAgent)) {
        this.Platform = "Android";
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      else if (/iPad|iPhone|iPod/.test(self.userAgent)) {
        this.Platform = "iOS";
      }

      self.myParam = this.$route.query.path;
      switch (self.myParam) {
        case "course":
          this.linkUri = "fusionseed://course";
          break;
        case "landing":
          this.linkUri = "fusionseed://landing";
          break;
        case "library":
          this.linkUri = "fusionseed://library";
          break;
        case "lessonlearn":
          this.linkUri = "fusionseed://lessonlearn";
          break;
        case "event":
          this.linkUri = "fusionseed://event";
          break;
        case "community":
          this.linkUri = "fusionseed://community";
          break;
        default:
          this.linkUri = "fusionseed://" + self.myParam;
          break;
      }
      this.RedirectMobileOperatingSystem(this.Platform, this.linkUri);
    },

    RedirectMobileOperatingSystem(Platform, linkUri) {
      let self = this;
      self.deeplink = linkUri;
      if (this.Platform == "Android") {
        window.open(self.deeplink, "_self");
      }
      if (this.Platform == "iOS") {
        window.open(self.deeplink, "_self");
      }
    }
  }
};
</script>

<style scoped>
.containerimg {
  background: url("~@/assets/imgs/Component 87 – 98@2x.png") no-repeat center
    center;
  background-size: cover;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #ffffff;
  transform: scale(1);
}
.logoimg {
  width: 150px;
  height: auto;
}
.phoneimg {
  width: 1500px;
  top: 1%;
}
.title {
  top: 11% !important;
}
.appleimg {
  top: 15% !important;
}
.appleimg {
  margin-left: 25px !important;
  width: 250px;
  top: 150% !important;
}
.googleimg {
  width: 250px;
  top: 150% !important;
}
</style>

<style scoped>
@media (min-width: 1264px) and (max-width: 1900px) {
  .logoimg {
    width: 120px;
    height: auto;
  }
  .phoneimg {
    width: 1200px !important;
    top: 1%;
  }
  .subtitle {
    font-size: 40px !important;
  }
}

@media (max-width: 1025px) {
  .logoimg {
    width: 90px;
    height: auto;
  }
  .phoneimg {
    width: 1100px !important;
    top: 1%;
  }
  .Title {
    font-size: 50px !important;
  }
  .subtitle {
    font-size: 36px !important;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .logoimg {
    width: 85px;
    height: auto;
  }
  .phoneimg {
    width: 500px !important;
    margin: auto !important;
  }
  .title {
    top: 0% !important;
  }
  .Title {
    text-align: center !important;
  }
  .subtitle {
    text-align: center !important;
    margin-top: 0px !important;
  }
  .appleimg {
    margin-left: 25px !important;
    width: 270px;
    top: 10% !important;
  }
  .googleimg {
    margin-left: 25px !important;
    width: 270px;
    top: 10% !important;
  }
}

@media (max-width: 430px) {
  .logoimg {
    margin-left: 15px;
  }
  .phoneimg {
    width: 400px !important;
    top: -10%;
    margin: auto !important;
  }
  .title {
    top: -50px !important;
  }
  .Title {
    text-align: center !important;
    font-size: 50px !important;
  }
  .subtitle {
    margin-top: 0px !important;
  }
  .appleimg {
    margin-left: 10px !important;
    top: -100% !important;
  }
  .googleimg {
    top: -100% !important;
    margin-left: -11px !important ;
  }
}

@media (max-width: 430px) {
  .phoneimg {
    width: 350px !important;
    top: -10%;
  }
  .title {
    padding: 0px !important;
  }
  .Title {
    font-size: 35px !important;
  }
  .subtitle {
    margin-top: 0px !important;
    font-size: 25px !important;
    text-align: center !important;
  }
}
@media (max-width: 360px) {
  .phoneimg {
    width: 330px !important;
  }
}
@media (max-width: 320px) {
  .logoimg {
    width: 70px !important;
  }
  .phoneimg {
    width: 250px !important;
  }
  .Title {
    font-size: 25px !important;
  }
  .subtitle {
    font-size: 20px !important;
  }
}
</style>
